import styled from 'styled-components';

import media from 'apps/auth/theme/media';

type ImageProps = {
    imgUrl?: string | null;
    dir?: string;
};

export const InputContainer = styled.label<{ imgUrl?: string | null }>`
    height: 166px;
    border-radius: 12px;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 17px;
    line-height: 24px;
    color: ${(props) => props.theme.purple_100};
    border: 1px solid ${(props) => props.theme.grey_28_tr};
    cursor: pointer;
    box-sizing: border-box;
    display: ${(props) => (props.imgUrl === '' || props.imgUrl === null || props.imgUrl === undefined ? 'flex' : 'none')};

    &:hover {
        background: ${(props) => props.theme.purple_8_tr};
    }

    ${media.tablet720} {
        height: 308px;
    }

    ${media.desktop1920} {
        font-size: 20px;
        line-height: 32px;
    }
`;

export const Input = styled.input`
    opacity: 0;
    height: 0;
`;

export const ReplaceContainer = styled.div`
    display: none;
    text-align: center;
`;

export const ImageContainer = styled.div<ImageProps>`
    height: 166px;
    border-radius: 12px;
    border: 1px solid ${(props) => props.theme.grey_28_tr};
    background: url(${(props) => `${props.dir ?? ''}${props.imgUrl ?? ''}`}) no-repeat center;
    background-size: cover;
    cursor: pointer;
    display: ${(props) => (props.imgUrl === '' || props.imgUrl === null || props.imgUrl === undefined ? 'none' : 'flex')};
    align-items: center;
    justify-content: center;
    position: relative;

    ${media.tablet720} {
        height: 308px;
    }

    &:hover {
        background:
            linear-gradient(0deg, rgba(55, 57, 57, 0.64), rgba(55, 57, 57, 0.64)),
            url(${(props) => `${props.dir ?? ''}${props.imgUrl ?? ''}`}) no-repeat center;
        background-size: cover;

        ${ReplaceContainer} {
            display: block;
        }
    }
`;
